module.exports = "<p>竖向</p>\n";